module.exports = __webpack_public_path__ + "media/images/countryrect/sn-b73ea3a5e1a460b0c4cb8cfae1ea2628.svg";